import React from "react"
import { withRouter } from "react-router-dom"
import ChooseTimeslotItem from "./choose_time_slot_item";
import { railsToJsTimezoneMap } from "../../util/timezone_utils";
import { formatDatetime } from "../../util/date_util";
import ScrollArrows from "../scroll_arrows"

class ChooseTimeModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selected: new Date(),
      selectedTime: "",
      dates: [],
      month: new Date(),
      currentDay: new Date(),
      confirmModal: false,
      isLargeScreen: true,
    }
    this.handler = this.handler.bind(this)
    this.applyTime = this.applyTime.bind(this)
    this.addMonth = this.addMonth.bind(this)
    this.subtractMonth = this.subtractMonth.bind(this)
    this.addDays = this.addDays.bind(this)
    this.subtractDays = this.subtractDays.bind(this)
    this.handleTimeSelect = this.handleTimeSelect.bind(this)
    this.updatePredicate = this.updatePredicate.bind(this)
    this.modalContentRef = React.createRef()
  }

  componentDidMount() {
    document.body.style.overflow = 'hidden';
    this.updatePredicate();
    window.addEventListener("resize", this.updatePredicate);

    let today_date = new Date()
    today_date.setDate(today_date.getDate() + 1)
    
    let previous_time_selected = ""

    if (this.props.contractorTimeSearch){
      previous_time_selected = parseInt(this.props.contractorTimeSearch)
    }

    if (this.props.contractorDateSearch) {
      today_date = new Date(this.props.contractorDateSearch)
      today_date.setHours(0, 0, 0, 0)
    }

    let dates = this.getDaysInMonth(today_date)
    let firstSelectable = this.props.contractorDateSearch ? today_date : this.getFirstSelectableDate(dates)

    this.setState({
      dates: dates,
      currentDay: firstSelectable,
      selected: firstSelectable,
      selectedTime: previous_time_selected,
      month: today_date
    })
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePredicate);
    document.body.style.overflow = 'unset';
  }

  updatePredicate() {
    this.setState({ isLargeScreen: window.innerWidth > 550 });
  }

  addDays() {
    let currentDay = new Date(this.state.currentDay)

    if (this.state.isLargeScreen) {
      currentDay.setDate(currentDay.getDate() + 10)
    } else {
      currentDay.setDate(currentDay.getDate() + 5)
    }

    if (currentDay.getMonth() !== this.state.currentDay.getMonth()) {
      currentDay.setDate(1)
    }

    let dates = this.getDaysInMonth(currentDay)
    let firstSelectable = this.getFirstSelectableDate(dates)
    this.setState({ dates: dates, currentDay: firstSelectable, month: currentDay, selected: firstSelectable, selectedTime: "" })
  }

  subtractDays() {
    let currentDay = new Date(this.state.currentDay)

    if (this.state.isLargeScreen) {
      if (currentDay.getDate() < 11 && currentDay.getDate() != 1) {
        currentDay.setDate(1)
      } else {
        currentDay.setDate(currentDay.getDate() - 10)
      }
    } else {
      if (currentDay.getDate() < 6 && currentDay.getDate() != 1) {
        currentDay.setDate(1)
      } else {
        currentDay.setDate(currentDay.getDate() - 5)
      }
    }

    let todayDate = new Date()

    todayDate.setDate(todayDate.getDate() + 1)

    if (currentDay < todayDate && !this.props.currentUser?.roles?.admin) {
      let dates = this.getDaysInMonth(todayDate)
      let firstSelectable = this.getFirstSelectableDate(dates)
      this.setState({ dates: dates, currentDay: firstSelectable, month: todayDate, selected: firstSelectable, selectedTime: "" })
    } else {
      let dates = this.getDaysInMonth(currentDay)
      let firstSelectable = this.getFirstSelectableDate(dates)
      this.setState({ dates: dates, currentDay: firstSelectable, month: currentDay, selected: firstSelectable, selectedTime: "" })
    }
  }

  applyTime() {
    if (this.state.selectedTime !== "") {
      if (this.props.rescheduleModal){
        this.props.changeParentState({ chooseTimeModalOpen: false, contractorDateSearch: new Date(this.state.selected.toLocaleString('en-US', { timeZone: railsToJsTimezoneMap[this.props.detected_timezone] })), contractorTimeSearch: this.state.selectedTime })
      } else {
      let newStateAppointments = this.props.appointments
      let newState = this.props.package_attributes
      delete newStateAppointments[this.props.selectedService]
      if (newState[this.props.selectedService] && newState[this.props.selectedService]["appointment_time"]){
        delete newState[this.props.selectedService]["appointment_time"]
      }
      if (newState[this.props.selectedService] && newState[this.props.selectedService]["contractor_id"]){
        delete newState[this.props.selectedService]["contractor_id"]
      }

        this.props.changeParentState({ appointments: newStateAppointments, package_attributes: newState, chooseTimeModalOpen: false, contractorDateSearch: new Date(this.state.selected.toLocaleString('en-US', { timeZone: railsToJsTimezoneMap[this.props.detected_timezone] })), contractorTimeSearch: this.state.selectedTime})
      }
    }
  }

  addMonth() {
    let date = new Date(this.state.month.getFullYear(), this.state.month.getMonth() + 1, 1)

    let dates = this.getDaysInMonth(date)
    let firstSelectable = this.getFirstSelectableDate(dates)
    this.setState({ dates: dates, month: date, currentDay: firstSelectable, selected: firstSelectable, selectedTime: "" })
  }

  subtractMonth() {
    let today_date = new Date()
    let date = new Date(this.state.month.getFullYear(), this.state.month.getMonth(), 1)

    if (date.getMonth() != today_date.getMonth() || this.props.currentUser?.roles?.admin) {
      date = new Date(this.state.month.getFullYear(), this.state.month.getMonth() - 1, 1)
    }

    let dates = this.getDaysInMonth(date)
    let firstSelectable = this.getFirstSelectableDate(dates)
    this.setState({ dates: dates, month: date, currentDay: firstSelectable, selected: firstSelectable, selectedTime: "" })
  }

  getDaysInMonth(date) {
    let month = date.getMonth()
    let year = date.getFullYear()
    let new_date = new Date(year, month, 1)
    let days = []
    while (new_date.getMonth() === month) {
      days.push(new Date(new_date))
      new_date.setDate(new_date.getDate() + 1)
    }
    return days
  }

  getFirstSelectableDate(dates) {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    return dates.find(d => {
      const normalized = new Date(d)
      normalized.setHours(0, 0, 0, 0)
      return normalized > today
    }) || dates[dates.length - 1]
  }

  changeSelected(index) {
    this.setState({ selected: this.state.dates[index], selectedTime: "" })
  }

  handler(newState) {
    this.setState(newState)
  }

  handleTimeSelect(time) {
    if (this.state.selectedTime === time) {
      this.setState({ selectedTime: "" })
    } else {
      this.setState({ selectedTime: time })
    }
  }


  render() {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const isAdmin = this.props.currentUser?.roles?.admin

    const isCurrentMonth = this.state.month.getMonth() === today.getMonth() &&
                           this.state.month.getFullYear() === today.getFullYear()

    const mostRecentSunday = new Date(today)
    mostRecentSunday.setDate(today.getDate() - today.getDay())
    mostRecentSunday.setHours(0, 0, 0, 0)

    const firstDate = this.state.dates[0]
    const fillerDays = []

    if (!isCurrentMonth || isAdmin || !firstDate || mostRecentSunday < firstDate) {
      const startDayOfWeek = firstDate ? firstDate.getDay() : 0
      for (let i = startDayOfWeek - 1; i >= 0; i--) {
        const fillerDate = new Date(firstDate.getFullYear(), firstDate.getMonth(), -i)
        fillerDays.push(
          <div className="createProjectDateOptions createProjectDateDisabled" key={`filler-${i}`}>
            <div className="createProjectDate">{fillerDate.getDate()}</div>
            <div className="createProjectDateDay">{fillerDate.toLocaleString('default', { weekday: 'short' })}</div>
          </div>
        )
      }
    }

    let dates = this.state.dates.map((date, index) => {
      if (isCurrentMonth && !isAdmin && firstDate && mostRecentSunday >= firstDate) {
        const normalized = new Date(date)
        normalized.setHours(0, 0, 0, 0)
        if (normalized < mostRecentSunday) return null
      }
      const normalized = new Date(date)
      normalized.setHours(0, 0, 0, 0)
      const isPast = normalized <= today
      const isSelected = this.state.selected?.toString() === date.toString()

      if (isPast) {
        return (
          <div className={`createProjectDateOptions createProjectDateDisabled${isAdmin ? " createProjectDateDisabledAdmin" : ""}`} key={index}
               id={isAdmin && isSelected ? "createProjectDateOptionSelected" : ""}
               onClick={isAdmin ? () => this.changeSelected(index) : undefined}>
            <div className="createProjectDate"
                 id={isAdmin && isSelected ? "createProjectDateSelected" : ""}>{date.getDate()}</div>
            <div className="createProjectDateDay"
                 id={isAdmin && isSelected ? "createProjectDateDaySelected" : ""}>{date.toLocaleString('default', { weekday: 'short' })}</div>
          </div>
        )
      }

      return (
        <div className="createProjectDateOptions" key={index}
             id={isSelected ? "createProjectDateOptionSelected" : ""}
             onClick={() => this.changeSelected(index)}>
          <div className="createProjectDate"
               id={isSelected ? "createProjectDateSelected" : ""}>{date.getDate()}</div>
          <div className="createProjectDateDay"
               id={isSelected ? "createProjectDateDaySelected" : ""}>{date.toLocaleString('default', { weekday: 'short' })}</div>
        </div>
      )
    })

    let selectedTime = this.state.selectedTime

    let timeSlotOptions = []

    let slots = [8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13, 13.5, 14, 14.5, 15, 15.5, 16, 16.5, 17, 17.5, 18, 18.5, 19, 19.5, 20, 20.5]
    let times = ["8:00 am", "8:30 am", "9:00 am", "9:30 am", "10:00 am", "10:30 am", "11:00 am", "11:30 am", "12:00 pm", "12:30 pm", "1:00 pm", "1:30 pm", "2:00 pm", "2:30 pm", "3:00 pm", "3:30 pm", "4:00 pm", "4:30 pm", "5:00 pm", "5:30pm", "6:00 pm", "6:30 pm", "7:00 pm", "7:30pm", "8:00", "8:30"];

    slots.forEach((slot, i) => {
      if (this.props.time_slots[this.state.selected ? this.state.selected.toLocaleString('en-us', { weekday: 'long' }) : new Date().toLocaleString('en-us', { weekday: 'long' })][slot]) {
        timeSlotOptions.push(<ChooseTimeslotItem key={i} currentUser={this.props.currentUser} time={times[i]} slot={slot} selected={selectedTime === slot}
          handleTimeSelect={this.handleTimeSelect} changeParentState={this.handler} />)
      }
    })

    let modalClass = "orderpreviewModal contractorSchedulingModal"

    if (this.props.homepageModal) {
      modalClass = "orderpreviewModal contractorSchedulingModalHomepage"
    }

    // .orderpreviewModal centers/sizes itself against the viewport via
    // position:absolute + a transform — it can't also be the scroll
    // container (that would need a position:relative ancestor for the
    // ScrollArrows zones, which breaks the centering transform's containing
    // block) or the arrows' own positioned parent (its overflow would just
    // scroll them away with the content). So this inner wrapper — not
    // .orderpreviewModal itself — is what scrolls. Needed everywhere this
    // renders, not just the homepage flow: on mobile, the extra flex layer
    // is what the full-screen CSS resolves height against.
    const scrollWrapperStyle = { position: "relative", display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }

    return <div className="modal-background contractor-calendar-mobile" onClick={() => this.props.changeParentState({ modalOpen: false })}>
      <div className={modalClass} onClick={e => e.stopPropagation()}>
      <div style={scrollWrapperStyle}>
        <div className="orderPreviewModalComponent" ref={this.modalContentRef}>
          {this.state.isLargeScreen ?
            <div className="contractorModalHeading">
              <div className="contractorModalDescription">Choose your date and time</div>
            </div> : ""}
          <div className="photographerSubheading photographerSubheadingTop">Below you will find the available dates and
            times.
          </div>
          <div className="mainSchedulingComponentGroup">
            <div className="dateSelectionGrouping" id="chooseTimeModalSelectionGrouping">
              <div className="contractorTimeSlotDateHeadingGroup">
                <div className="contractorTimeSlotsHeading">
                  <div className="selectedWeekday">
                    {this.state.selected ? formatDatetime(this.state.selected, "dddd", this.props.detected_timezone) : ''},
                  </div>
                  <div
                    className="selectedMonth">{this.state.selected ? formatDatetime(this.state.selected, "MMMM", this.props.detected_timezone) : ''} </div>
                  <div className="selectedDate">{this.state.selected ? formatDatetime(this.state.selected, "DD", this.props.detected_timezone) + ', ' : ''}</div>
                  <div className="selectedDate">{this.state.selected ? formatDatetime(this.state.selected, "YYYY", this.props.detected_timezone) : ''}</div>
                </div>
                <div className="selectedArrows">
                  <div onClick={this.subtractMonth} className="selectedArrowLeft"><i className="fas fa-chevron-left"></i>
                  </div>
                  <div className="selectedArrowMonth">{this.state.month.toLocaleString('default', { month: 'long' })}</div>
                  <div onClick={this.addMonth} className="selectedArrowRight"><i className="fas fa-chevron-right"></i>
                  </div>
                </div>
              </div>
              <div className="daysGroupDiv">
                <div className="contractorTimeSlotsDates">
                  {fillerDays}
                  {dates}
                </div>
              </div>
            </div>
            <div className="timeSlotGrouping">
              <div className="selectTime">Select time</div>
              {this.props.detected_timezone && <div className="small mb-3">
                Times are shown in {this.props.detected_timezone}
              </div>}
              <div className="timesDiv">
                {timeSlotOptions.length > 0 ? timeSlotOptions : <div className="noTimeslotsDiv">No timeslots for this date</div>}
              </div>
            </div>
          </div>
          <div className="contractorTimeSlotsButtons">
            <div onClick={() => this.props.changeParentState({chooseTimeModalOpen: false})} className="signupFormPrevious">Cancel</div>
            <div onClick={this.applyTime} className="signupFormNext" id={this.state.selectedTime === "" ? 'disabled' : ''}>Apply</div>
          </div>
        </div>
        {this.props.homepageModal && <ScrollArrows scrollRef={this.modalContentRef} />}
      </div>
      <div className="modalMobilePushup"></div>
      </div>
    </div>
  }
}

export default withRouter(ChooseTimeModal)